import { Injectable } from '@angular/core';
import { ApiCallHandler } from '../../modules/core/models/apiCallHandler';
import { EoHttpClient, IHttpParams } from 'ngx-eo-web-components';
import { CoreService } from '../../modules/core/core.service';
import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { PaginatedSearchOptions } from '../../modules/core/models/paginated-search-options.model';
import { Drg } from '../../modules/core/models/drg.model';

@Injectable({
  providedIn: 'root',
})
export class DrgService {
  public viewOptions$ = new BehaviorSubject<PaginatedSearchOptions>(
    new PaginatedSearchOptions()
  );
  public drgListCallHandler = new ApiCallHandler<Drg[]>();

  constructor(
    private http: EoHttpClient,
    private coreService: CoreService
  ) {}

  init() {
    this.drgListCallHandler.init([]);
  }

  getAllDrgs() {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Drgs/list`,
      this.drgListCallHandler
    );

    return this.http.get<Drg[]>(param);
  }

  searchDrgs(term: string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Drgs/search/${term}`,
      this.drgListCallHandler
    );

    return this.http.get<Drg[]>(param);
  }
}
